import { bootstrapApplication } from '@angular/platform-browser';
import { registerLicense } from '@syncfusion/ej2-base';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

registerLicense('Ngo9BigBOggjHTQxAR8/V1JGaF5cXGpCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWX5cdnVTRGBYWUZ1WEFWZ0k=');

bootstrapApplication(AppComponent, appConfig)
  .then(() => document.documentElement.classList.add('spa-ready'))
  .catch((err) => {
    console.error(err);
    const el = document.getElementById('spa-fallback');
    if (el) {
      el.textContent = 'App failed to start: ' + (err?.message || String(err));
    }
  });
